<footer class="footer not-printable">
    <div class="container-fluid">
        <div class="copyright pull-left">
            &copy; {{year | date: 'yyyy'}} OÖ Landestierschutzverein
        </div>
    </div>
</footer>
